import { onBeforeMount, watch } from 'vue'

import type { DisciplineInKid } from '@brighterly/lib-core-types/discipline/interfaces'
import type { WatchStopHandle } from 'vue'

import { useDisciplineStore } from './discipline-store/store'

type OnDisciplineReadyCallback = (discipline: DisciplineInKid) => void | Promise<void>

interface Options {
  once?: boolean
  hook?: 'onBeforeMount' | 'NONE'
}
export const onDisciplineReady = (callback: OnDisciplineReadyCallback, options: Options = { hook: 'onBeforeMount' }): () => void => {
  const { once = true } = options
  const store = useDisciplineStore()

  let stop: WatchStopHandle | null = null
  let ran = false

  const run = async (): Promise<void> => {
    if (ran || !store.activeDiscipline) return
    ran = true

    await callback(store.activeDiscipline)

    if (once && stop) {
      stop()
      stop = null
    }
  }

  const initListener = (): void => {
    if (store.activeDiscipline) {
      run()
    } else {

      stop = watch(
        () => store.activeDiscipline,
        (customer, prev) => {
          if (customer && !prev) {
            run()
          }
          if (once && ran && stop) {
            stop()
            stop = null
          }
        },
        { flush: 'post' },
      )
    }
  }

  if (options?.hook === 'onBeforeMount') {
    onBeforeMount(initListener)
  } else if (options?.hook === 'NONE') {
    initListener()
  }

  return () => {
    if (stop) {
      stop()
      stop = null
    }
  }
}
